/**
 * Configuración de Firebase para la aplicación web.
 * Usa las mismas credenciales que la app móvil.
 */

import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Configuración de Firebase (misma que la app móvil)
const firebaseConfig = {
  apiKey: "AIzaSyBeYSNLM_e-LQAwp0J5BsAtYxJ5gHgWZAk",
  authDomain: "amarsisup.firebaseapp.com",
  projectId: "amarsisup",
  storageBucket: "amarsisup.appspot.com",
  messagingSenderId: "882342491502",
  appId: "1:882342491502:web:e0df4362e1024f32f6fd7f",
  measurementId: "G-5YFEX6P5Y3"
};

// Inicializa la app de Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// Inicializa el almacenamiento
export const storage = getStorage(firebaseApp);

// Inicializa Firebase Auth
export const auth = getAuth(firebaseApp);
